import React from 'react';
import ReactDOM from 'react-dom/client';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import './index.css';
import App from './App';

if (mapboxgl.accessToken) {
  console.warn('mapboxgl.accessToken already defined');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);